/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Document } from '../models/Document';
import type { DownloadResponse } from '../models/DownloadResponse';
import type { PaginatedDocumentList } from '../models/PaginatedDocumentList';
import type { PaginatedDocumentTypeList } from '../models/PaginatedDocumentTypeList';
import type { PatchedPatchedDocument } from '../models/PatchedPatchedDocument';
import type { ReplaceRequest } from '../models/ReplaceRequest';
import type { ReplaceRequestResponse } from '../models/ReplaceRequestResponse';
import type { UploadRequest } from '../models/UploadRequest';
import type { UploadRequestResponse } from '../models/UploadRequestResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DocumentsService {

    /**
     * Document management endpoints.
     *
     * list:           GET    /documents/                     — list documents for current context
     * retrieve:       GET    /documents/{id}/                — get document detail
     * destroy:        DELETE /documents/{id}/                — soft-delete a document
     * partial_update: PATCH  /documents/{id}/                — update label / dates (owner only)
     * upload:         POST   /documents/upload-request/      — request a presigned upload URL
     * confirm:        POST   /documents/{id}/confirm/        — confirm upload completed
     * download:       GET    /documents/{id}/download/       — get a presigned download URL
     * replace:        POST   /documents/{id}/replace/        — request a presigned replace URL
     * confirm-replace:POST   /documents/{id}/confirm-replace/— confirm replacement upload
     *
     * Security layers:
     * 1. HasDocumentContextPermission.has_permission — validates security context
     * 2. get_queryset — scopes to docs the user owns/is related to + audience can download
     * 3. HasDocumentContextPermission.has_object_permission — action-specific audience checks
     * 4. Service layer — defense in depth (upload/replace/download audience checks)
     * @returns PaginatedDocumentList
     * @throws ApiError
     */
    public static documentsList({
        contextId,
        contextType,
        documentType,
        limit,
        offset,
        ordering,
        search,
    }: {
        contextId?: string,
        contextType?: string,
        documentType?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedDocumentList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/documents/',
            query: {
                'context_id': contextId,
                'context_type': contextType,
                'document_type': documentType,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'search': search,
            },
        });
    }

    /**
     * Document management endpoints.
     *
     * list:           GET    /documents/                     — list documents for current context
     * retrieve:       GET    /documents/{id}/                — get document detail
     * destroy:        DELETE /documents/{id}/                — soft-delete a document
     * partial_update: PATCH  /documents/{id}/                — update label / dates (owner only)
     * upload:         POST   /documents/upload-request/      — request a presigned upload URL
     * confirm:        POST   /documents/{id}/confirm/        — confirm upload completed
     * download:       GET    /documents/{id}/download/       — get a presigned download URL
     * replace:        POST   /documents/{id}/replace/        — request a presigned replace URL
     * confirm-replace:POST   /documents/{id}/confirm-replace/— confirm replacement upload
     *
     * Security layers:
     * 1. HasDocumentContextPermission.has_permission — validates security context
     * 2. get_queryset — scopes to docs the user owns/is related to + audience can download
     * 3. HasDocumentContextPermission.has_object_permission — action-specific audience checks
     * 4. Service layer — defense in depth (upload/replace/download audience checks)
     * @returns Document
     * @throws ApiError
     */
    public static documentsRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this document.
         */
        id: string,
    }): CancelablePromise<Document> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/documents/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Document management endpoints.
     *
     * list:           GET    /documents/                     — list documents for current context
     * retrieve:       GET    /documents/{id}/                — get document detail
     * destroy:        DELETE /documents/{id}/                — soft-delete a document
     * partial_update: PATCH  /documents/{id}/                — update label / dates (owner only)
     * upload:         POST   /documents/upload-request/      — request a presigned upload URL
     * confirm:        POST   /documents/{id}/confirm/        — confirm upload completed
     * download:       GET    /documents/{id}/download/       — get a presigned download URL
     * replace:        POST   /documents/{id}/replace/        — request a presigned replace URL
     * confirm-replace:POST   /documents/{id}/confirm-replace/— confirm replacement upload
     *
     * Security layers:
     * 1. HasDocumentContextPermission.has_permission — validates security context
     * 2. get_queryset — scopes to docs the user owns/is related to + audience can download
     * 3. HasDocumentContextPermission.has_object_permission — action-specific audience checks
     * 4. Service layer — defense in depth (upload/replace/download audience checks)
     * @returns Document
     * @throws ApiError
     */
    public static documentsPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this document.
         */
        id: string,
        requestBody?: PatchedPatchedDocument,
    }): CancelablePromise<Document> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/documents/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Document management endpoints.
     *
     * list:           GET    /documents/                     — list documents for current context
     * retrieve:       GET    /documents/{id}/                — get document detail
     * destroy:        DELETE /documents/{id}/                — soft-delete a document
     * partial_update: PATCH  /documents/{id}/                — update label / dates (owner only)
     * upload:         POST   /documents/upload-request/      — request a presigned upload URL
     * confirm:        POST   /documents/{id}/confirm/        — confirm upload completed
     * download:       GET    /documents/{id}/download/       — get a presigned download URL
     * replace:        POST   /documents/{id}/replace/        — request a presigned replace URL
     * confirm-replace:POST   /documents/{id}/confirm-replace/— confirm replacement upload
     *
     * Security layers:
     * 1. HasDocumentContextPermission.has_permission — validates security context
     * 2. get_queryset — scopes to docs the user owns/is related to + audience can download
     * 3. HasDocumentContextPermission.has_object_permission — action-specific audience checks
     * 4. Service layer — defense in depth (upload/replace/download audience checks)
     * @returns void
     * @throws ApiError
     */
    public static documentsDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this document.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/documents/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Document management endpoints.
     *
     * list:           GET    /documents/                     — list documents for current context
     * retrieve:       GET    /documents/{id}/                — get document detail
     * destroy:        DELETE /documents/{id}/                — soft-delete a document
     * partial_update: PATCH  /documents/{id}/                — update label / dates (owner only)
     * upload:         POST   /documents/upload-request/      — request a presigned upload URL
     * confirm:        POST   /documents/{id}/confirm/        — confirm upload completed
     * download:       GET    /documents/{id}/download/       — get a presigned download URL
     * replace:        POST   /documents/{id}/replace/        — request a presigned replace URL
     * confirm-replace:POST   /documents/{id}/confirm-replace/— confirm replacement upload
     *
     * Security layers:
     * 1. HasDocumentContextPermission.has_permission — validates security context
     * 2. get_queryset — scopes to docs the user owns/is related to + audience can download
     * 3. HasDocumentContextPermission.has_object_permission — action-specific audience checks
     * 4. Service layer — defense in depth (upload/replace/download audience checks)
     * @returns Document
     * @throws ApiError
     */
    public static documentsConfirmCreate({
        id,
    }: {
        /**
         * A UUID string identifying this document.
         */
        id: string,
    }): CancelablePromise<Document> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/documents/{id}/confirm/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Document management endpoints.
     *
     * list:           GET    /documents/                     — list documents for current context
     * retrieve:       GET    /documents/{id}/                — get document detail
     * destroy:        DELETE /documents/{id}/                — soft-delete a document
     * partial_update: PATCH  /documents/{id}/                — update label / dates (owner only)
     * upload:         POST   /documents/upload-request/      — request a presigned upload URL
     * confirm:        POST   /documents/{id}/confirm/        — confirm upload completed
     * download:       GET    /documents/{id}/download/       — get a presigned download URL
     * replace:        POST   /documents/{id}/replace/        — request a presigned replace URL
     * confirm-replace:POST   /documents/{id}/confirm-replace/— confirm replacement upload
     *
     * Security layers:
     * 1. HasDocumentContextPermission.has_permission — validates security context
     * 2. get_queryset — scopes to docs the user owns/is related to + audience can download
     * 3. HasDocumentContextPermission.has_object_permission — action-specific audience checks
     * 4. Service layer — defense in depth (upload/replace/download audience checks)
     * @returns Document
     * @throws ApiError
     */
    public static documentsConfirmReplaceCreate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this document.
         */
        id: string,
        requestBody: ReplaceRequest,
    }): CancelablePromise<Document> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/documents/{id}/confirm-replace/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Document management endpoints.
     *
     * list:           GET    /documents/                     — list documents for current context
     * retrieve:       GET    /documents/{id}/                — get document detail
     * destroy:        DELETE /documents/{id}/                — soft-delete a document
     * partial_update: PATCH  /documents/{id}/                — update label / dates (owner only)
     * upload:         POST   /documents/upload-request/      — request a presigned upload URL
     * confirm:        POST   /documents/{id}/confirm/        — confirm upload completed
     * download:       GET    /documents/{id}/download/       — get a presigned download URL
     * replace:        POST   /documents/{id}/replace/        — request a presigned replace URL
     * confirm-replace:POST   /documents/{id}/confirm-replace/— confirm replacement upload
     *
     * Security layers:
     * 1. HasDocumentContextPermission.has_permission — validates security context
     * 2. get_queryset — scopes to docs the user owns/is related to + audience can download
     * 3. HasDocumentContextPermission.has_object_permission — action-specific audience checks
     * 4. Service layer — defense in depth (upload/replace/download audience checks)
     * @returns DownloadResponse
     * @throws ApiError
     */
    public static documentsDownloadRetrieve({
        id,
        disposition,
    }: {
        /**
         * A UUID string identifying this document.
         */
        id: string,
        disposition?: string,
    }): CancelablePromise<DownloadResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/documents/{id}/download/',
            path: {
                'id': id,
            },
            query: {
                'disposition': disposition,
            },
        });
    }

    /**
     * Document management endpoints.
     *
     * list:           GET    /documents/                     — list documents for current context
     * retrieve:       GET    /documents/{id}/                — get document detail
     * destroy:        DELETE /documents/{id}/                — soft-delete a document
     * partial_update: PATCH  /documents/{id}/                — update label / dates (owner only)
     * upload:         POST   /documents/upload-request/      — request a presigned upload URL
     * confirm:        POST   /documents/{id}/confirm/        — confirm upload completed
     * download:       GET    /documents/{id}/download/       — get a presigned download URL
     * replace:        POST   /documents/{id}/replace/        — request a presigned replace URL
     * confirm-replace:POST   /documents/{id}/confirm-replace/— confirm replacement upload
     *
     * Security layers:
     * 1. HasDocumentContextPermission.has_permission — validates security context
     * 2. get_queryset — scopes to docs the user owns/is related to + audience can download
     * 3. HasDocumentContextPermission.has_object_permission — action-specific audience checks
     * 4. Service layer — defense in depth (upload/replace/download audience checks)
     * @returns ReplaceRequestResponse
     * @throws ApiError
     */
    public static documentsReplaceCreate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this document.
         */
        id: string,
        requestBody: ReplaceRequest,
    }): CancelablePromise<ReplaceRequestResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/documents/{id}/replace/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * list: GET /api/documents/types/ — list active document types relevant to
     * the current user's audience. Staff sees all types.
     * @returns PaginatedDocumentTypeList
     * @throws ApiError
     */
    public static documentsTypesList({
        contextTypes,
        limit,
        offset,
    }: {
        /**
         * Multiple values may be separated by commas.
         */
        contextTypes?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
    }): CancelablePromise<PaginatedDocumentTypeList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/documents/types/',
            query: {
                'context_types': contextTypes,
                'limit': limit,
                'offset': offset,
            },
        });
    }

    /**
     * Document management endpoints.
     *
     * list:           GET    /documents/                     — list documents for current context
     * retrieve:       GET    /documents/{id}/                — get document detail
     * destroy:        DELETE /documents/{id}/                — soft-delete a document
     * partial_update: PATCH  /documents/{id}/                — update label / dates (owner only)
     * upload:         POST   /documents/upload-request/      — request a presigned upload URL
     * confirm:        POST   /documents/{id}/confirm/        — confirm upload completed
     * download:       GET    /documents/{id}/download/       — get a presigned download URL
     * replace:        POST   /documents/{id}/replace/        — request a presigned replace URL
     * confirm-replace:POST   /documents/{id}/confirm-replace/— confirm replacement upload
     *
     * Security layers:
     * 1. HasDocumentContextPermission.has_permission — validates security context
     * 2. get_queryset — scopes to docs the user owns/is related to + audience can download
     * 3. HasDocumentContextPermission.has_object_permission — action-specific audience checks
     * 4. Service layer — defense in depth (upload/replace/download audience checks)
     * @returns UploadRequestResponse
     * @throws ApiError
     */
    public static documentsUploadRequestCreate({
        requestBody,
    }: {
        requestBody: UploadRequest,
    }): CancelablePromise<UploadRequestResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/documents/upload-request/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
